import { isProduction, isReviewApp, isStaging } from "./env";

const isHostedReviewApp = isReviewApp && process.env.NEXT_PUBLIC_APP_ENV === "review-app";

export const favicon = isProduction
  ? "/favicon.ico"
  : isStaging
    ? "/favicon-stage.ico"
    : isHostedReviewApp
      ? "/favicon-preview.ico"
      : "/favicon-dev.ico";
